import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    this.element.style.cursor = 'grab';
    this.isDragging = false;

    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.element.addEventListener('mousedown', this.start.bind(this), { signal });
    this.element.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
  }

  disconnect() {
    this.abortController?.abort();
    this.dragAbortController?.abort();
  }

  start(event) {
    this.isDragging = true;
    this.element.style.cursor = 'grabbing';
    this.element.style.userSelect = 'none';
    this.startX = event.pageX;
    this.startScrollLeft = this.element.scrollLeft;

    this.dragAbortController = new AbortController();
    const { signal } = this.dragAbortController;
    document.addEventListener('mousemove', this.move.bind(this), { signal });
    document.addEventListener('mouseup', this.end.bind(this), { signal });
  }

  move(event) {
    if (!this.isDragging) return;
    this.element.scrollLeft = this.startScrollLeft - (event.pageX - this.startX);
  }

  end() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.element.style.cursor = 'grab';
    this.element.style.userSelect = '';
    this.dragAbortController?.abort();
  }
}
